<template>
  <video
    class="video video-aspect-ratio"
    style="object-fit: cover; position: absolute; left: 0; right: 0"
    autoPlay
    muted
    playsInline
    ref="videoEl"
  />
</template>

<script>
export default {
  props: ["track"],
  name: "VideoTrack",
  mounted() {
    this.$refs.videoEl.srcObject = new MediaStream([this.track]);
  },
  watch: {
    track(newTrack) {
      this.$refs.videoEl.srcObject = new MediaStream([newTrack]);
    },
  },
};
</script>

<style scoped lang="scss">
.video-aspect-ratio {
  aspect-ratio: 288 / 232;
  width: 100%;
}
</style>
